// Formats d'affichage communs (FCFA, dates, heures).

/** 6093954 -> « 6 093 954 » (espaces comme séparateurs de milliers) */
export const fcfa = (n) => {
  const v = Math.round(Number(n) || 0);
  return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/** '2026-08-10' ou '2026-08-10T00:00:00.000Z' -> '10/08/2026' */
export const dateFr = (d) => {
  if (!d) return '';
  const s = String(d).slice(0, 10);
  const [y, m, day] = s.split('-');
  return day && m && y ? `${day}/${m}/${y}` : s;
};

/** Horodatage -> '12/10/2026 à 10:42' (heure locale du navigateur) */
export const dateHeureFr = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} à ${p(d.getHours())}:${p(d.getMinutes())}`;
};

/** '10:00:00' -> '10:00' */
export const heure = (t) => (t ? String(t).slice(0, 5) : '');

export const today = () => new Date().toISOString().slice(0, 10);

/** Message d'erreur lisible depuis une réponse axios */
export const apiError = (err, fallback = 'Une erreur est survenue') =>
  err?.response?.data?.error || err?.message || fallback;

/** Découpe une saisie de numéros de poteaux (séparateurs : tiret, virgule, espace, retour à la ligne) */
export const parsePoleNumbers = (text) =>
  String(text || '').split(/[\s,;\-–]+/).map((s) => s.trim()).filter(Boolean);

export const BL_STATUS = {
  EN_COURS: { label: 'Brouillon', color: 'warning' },
  VALIDEE: { label: 'Scellé', color: 'success' },
  ANNULEE: { label: 'Annulé', color: 'default' },
};

export const INVOICE_STATUS = {
  BROUILLON: { label: 'À valider', color: 'warning' },
  EMISE: { label: 'Émise', color: 'info' },
  PAYEE: { label: 'Payée', color: 'success' },
  ANNULEE: { label: 'Annulée', color: 'error' },
};

export const PROFORMA_STATUS = {
  BROUILLON: { label: 'À valider', color: 'warning' },
  EMISE: { label: 'Envoyée au client', color: 'info' },
  ACCEPTEE: { label: 'Acceptée', color: 'success' },
  REFUSEE: { label: 'Refusée', color: 'error' },
  FACTUREE: { label: 'Facturée', color: 'success' },
};

export const PAYMENT_MODES = {
  VIREMENT: 'Virement', CHEQUE: 'Chèque', ESPECES: 'Espèces', MOBILE_MONEY: 'Mobile money', AUTRE: 'Autre',
};
